export default defineNuxtPlugin((nuxtApp) => {
  const appKey = 'f147d492c07096ac05fb602dde0bdb85';
  Kakao.init(appKey);
});
